import {Component, Input, OnInit} from "@angular/core";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {CustomDropdownComponent} from "../../../../shared/components/custom-dropdown/custom-dropdown.component";
import {TranslateModule} from "@ngx-translate/core";
import {
  CustomSearchInputComponent
} from "../../../../shared/components/custom-search-input/custom-search-input.component";
import {ScrollableWallComponent} from "../../../../shared/components/scrollable-wall/scrollable-wall.component";
import {ChatRoomItemComponent} from "../../../../shared/components/chat-room-item/chat-room-item.component";
import {
  SkeletonMessagesComponent
} from "../../../../shared/components/skeleton-cards/skeleton-messages/skeleton-messages.component";
import {Router, RouterLink} from "@angular/router";
import {HttpService} from "../../../../core/services/http.service";
import {RoomService} from "../../../../core/services/room.service";
import {SocketMainService} from "../../../../core/services/socket/socket-main-service";
import {SoundManagerService} from "../../../../core/services/sound-manager.service";
import {PopupHelperService} from "../../../../core/services/popup-helper.service";
import {StorageService} from "../../../../core/services/storage.service";
import {EventManagerService} from "../../../../core/services/event-manager.service";
import {appConstants} from "../../../../constants";
import {TabsComponent} from "../../../../shared/new-components/tabs/tabs.component";
import {SkeletonComponent} from "../../../../shared/components/skeleton/skeleton.component";
import {DropdownComponent} from "../../../../ui-lib/dropdown/dropdown.component";

@Component({
  selector: 'app-messages-dropdown',
  templateUrl: './messages-dropdown.component.html',
  standalone: true,
  imports: [
    NgIf,
    CustomDropdownComponent,
    TranslateModule,
    NgClass,
    CustomSearchInputComponent,
    ScrollableWallComponent,
    ChatRoomItemComponent,
    SkeletonMessagesComponent,
    RouterLink,
    NgForOf,
    TabsComponent,
    SkeletonComponent,
    DropdownComponent,
  ],
  providers: [HttpService, RoomService, SoundManagerService, PopupHelperService],
  styleUrls: ['./messages-dropdown.component.scss']
})
export class MessagesDropdownComponent implements OnInit {
  showMessagesDropDown = false;
  rooms: any = [];
  chatTabs = [
    {
      label: "individual",
      key: "individual",
      count: 0
    },
    {
      label: "group",
      key: "group",
      count: 0
    },
    {
      label: "generated",
      key: "generated",
      count: 0
    }
  ];
  @Input() forMobile = false;
  @Input() onlyOne = false;
  @Input() dropClassName:any;
  notSeenRoomCounts: number = 0
  messagesInfo: any = []
  loading = false;
  next: any
  loadingMore: boolean = false
  key: any
  currentUser = StorageService.getJsonItem(StorageService.statics.currentUser)
  activeTab: string = 'generated'
  individualNotSeenRoomsCount: number = 0
  groupNotSeenRoomsCount: number = 0
  generatedNotSeenRoomsCount: number = 0
  options: any = ['create_room'];
  updateVariable = 1
  openInviteDropDawnOptions: boolean = false


  constructor(private eventManager: EventManagerService,
              private roomService: RoomService,
              private socketService: SocketMainService,
              private soundService: SoundManagerService,
              private router: Router,
              private popupHelperService: PopupHelperService) {
  }

  ngOnInit(): void {
    this.currentUser = StorageService.getJsonItem(StorageService.statics.currentUser)
    let firstTime = true;
    let initialInfo = StorageService.getJsonItem(StorageService.statics.initialInfo)
    if(initialInfo){
      this.messagesInfo = initialInfo.notSeenRooms
      this.notSeenRoomCounts = this.messagesInfo.length
      this.individualNotSeenRoomsCount = this.messagesInfo.filter((obj:any) => obj.type === 'individual').length;
      this.groupNotSeenRoomsCount = this.messagesInfo.filter((obj:any) => obj.type === 'group' && !obj.forId ).length;
      this.generatedNotSeenRoomsCount = this.messagesInfo.filter((obj:any) => (obj.type === 'group' && obj.forId) || obj.type === 'forAdmin').length;
      this.chatTabs[0].count = this.individualNotSeenRoomsCount;
      this.chatTabs[1].count = this.groupNotSeenRoomsCount;
      this.chatTabs[2].count = this.generatedNotSeenRoomsCount;
    }

    this.eventManager.initialInfoEmitter.subscribe((data: any) => {
      let initialInfo = StorageService.getJsonItem(StorageService.statics.initialInfo)
      if (data.notSeenRooms) {
        firstTime = false;
        this.messagesInfo = data.notSeenRooms
        initialInfo.notSeenRooms = data.notSeenRooms
        this.notSeenRoomCounts = this.messagesInfo.length;
        this.individualNotSeenRoomsCount = this.messagesInfo.filter((obj:any) => obj.type === 'individual').length;
        this.groupNotSeenRoomsCount = this.messagesInfo.filter((obj:any) => obj.type === 'group' && !obj.forId ).length;
        this.generatedNotSeenRoomsCount = this.messagesInfo.filter((obj:any) => (obj.type === 'group' && obj.forId) || obj.type === 'forAdmin').length;
        this.chatTabs[0].count = this.individualNotSeenRoomsCount;
        this.chatTabs[1].count = this.groupNotSeenRoomsCount;
        this.chatTabs[2].count = this.generatedNotSeenRoomsCount;

      }
      StorageService.setJsonItem(StorageService.statics.initialInfo, initialInfo)
    })
    this.socketService.listenToEventWithCallback(appConstants.ACTIONTYPES.UPDATE, appConstants.EVENTTYPES.USER, (date: any) => {

      if (date.newMessage) {
        if (!firstTime && StorageService.getItem(StorageService.statics.soundEnabled) == 'true') {
          this.soundService.audioMessage.play();
        }
        let index = this.messagesInfo.map(function (e: any) {
          return e._id;
        }).indexOf(date.newMessage.roomId)

        if (index >= 0) {
          // if (this.messagesInfo[index].messagesCount <= 0) {
          //   this.messagesInfo.splice(index, 1);
          // }
        } else {
          this.messagesInfo.push({
            _id: date.newMessage.roomId,
            type: date.newMessage.roomType,
            forId: date.newMessage.roomForId
          })
        }
        if (this.rooms) {
          let index = this.rooms.map(function (e: any) {
            return e._id;
          }).indexOf(date.newMessage.roomId)
          if (index >= 0) {
            let accountIndex = this.rooms[index].accounts.findIndex((x:any)=> x.accountId._id === this.currentUser.userId)
            if(accountIndex >= 0){
              if(this.rooms[index].accounts[accountIndex].notSeenMessagesCount >= 0){
                this.rooms[index].accounts[accountIndex].notSeenMessagesCount = this.rooms[index].accounts[accountIndex].notSeenMessagesCount + date.newMessage.messagesCount
              }else {
                this.rooms[index].accounts[accountIndex].notSeenMessagesCount = date.newMessage.messagesCount
              }
              this.rooms[index].updateVariable = this.rooms[index].updateVariable?this.rooms[index].updateVariable + 1: 1
            }
          }
        }
        this.eventManager.openChatWidget({newMessage: date.newMessage})
        this.eventManager.changeRoomMessageComponent(date.newMessage.message)
        this.eventManager.initialInfo({notSeenRooms: this.messagesInfo})

      }

    })

    this.eventManager.seenRoomMessagesEmitter.subscribe((roomId: string) => {
      if (this.messagesInfo) {
        let index = this.messagesInfo.map(function (e: any) {
          return e._id;
        }).indexOf(roomId)
        if (index >= 0) {
          this.messagesInfo.splice(index, 1);
          if (this.rooms) {
            let roomIndex = this.rooms.map(function (e: any) {
              return e._id;
            }).indexOf(roomId)
            if (roomIndex >= 0) {
              this.rooms[roomIndex].notSeenMessagesCount = 0
              let accountIndex = this.rooms[roomIndex].accounts.findIndex((x:any) => x.accountId._id === this.currentUser.userId)
              if(accountIndex >= 0){
                this.rooms[roomIndex].accounts[accountIndex].notSeenMessagesCount = 0
              }
            }
          }
          this.eventManager.initialInfo({notSeenRooms: this.messagesInfo})
        }

      }
    })

    this.eventManager.deleteChatRoomEmitter.subscribe((roomId: string)=>{
      if(this.rooms && this.rooms.length > 0){
        let index = this.rooms.map(function (e:any) {
          return e._id;
        }).indexOf(roomId)
        if (index >= 0){
          this.rooms.splice(index, 1);
        }
      }
    })

  }

  showTab(tab: any){
    this.activeTab = tab.key
    this.getRooms()
  }

  onOpen(): void {
    this.updateVariable++
    this.eventManager.menuTrigger.emit(3);
    this.loading = true;
    this.openInviteDropDawnOptions = false

    this.roomService.getItems({limit: 10}, {sortBy: 'updatedAt', type: this.activeTab}).subscribe((data: any) => {
      this.loading = false;
      if (!data.hasError) {
        this.rooms = data.data.data
        if (data.data.next && data.data.next !== '') {
          this.next = data.data.next
        } else {
          this.next = null
        }
      }
    })
  }

  onClose(): void {
    this.eventManager.menuTrigger.emit(-1);
    this.rooms = null
  }

  markAllAsRead() {
    this.roomService.markAllAsRead().subscribe((data:any) => {
      if (!data.hasError) {
        for (let i = 0; i < data.data.roomIds.length; i++) {
          this.eventManager.seenRoomMessages(data.data.roomIds[i])
        }
      }
    })
  }

  getRooms(key = null) {
    this.key = key
    this.loading = true;
    this.rooms = []
    this.roomService.getItems({limit: 10}, {key: key, sortBy: 'updatedAt', type: this.activeTab}).subscribe((data: any) => {
      this.loading = false;
      if (!data.hasError) {
        this.rooms = data.data.data
        if (data.data.next && data.data.next) {
          this.next = data.data.next
        } else {
          this.next = null
        }
      }
    })
  }

  loadMore() {
    if (!this.loadingMore && this.next && this.next !== '') {
      this.loadingMore = true
      this.loading = true;
      this.roomService.getItems({next: this.next}, {key: this.key, limit: 10, sortBy: 'updatedAt', type: this.activeTab}).subscribe((data: any) => {
        if (!data.hasError) {
          this.rooms = this.rooms.concat(data.data.data)
          if (data.data.next && data.data.next !== '') {
            this.next = data.data.next
          } else {
            this.next = null
          }
        }

        this.loading = false;
        this.loadingMore = false
      }, () => {
        this.loading = false;
      })
    }

  }


  openChatWidget(room: any) {
    this.eventManager.openChatWidget({room: room, openMessages: true})
    this.onClose()
  }

  viewAll(){
    this.onClose()
    this.router.navigate(['/messages']);
  }

  deleteRoom(roomId: string) {
    this.roomService.delete(roomId).subscribe((data: any) => {
      if (!data.hasError) {
        this.popupHelperService.printSuccess();
      }else {
        console.log('errorMessages', data.errorMessages[0].msg)
      }
    })
  }



  openCreateRoomModal(){
    this.openInviteDropDawnOptions = false
    this.eventManager.openChatRoomOptionsModal({createRoom: true})
    this.onClose()
  }

  editRoom(roomId: string){
    this.openInviteDropDawnOptions = false
    this.eventManager.openChatRoomOptionsModal({editRoomId: roomId})
    this.onClose()
  }

  res(event: any) {
    if (event.event == 'create_room'){
      this.openCreateRoomModal()
    }
  }
}
